<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Insurance Packages",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Insurance Packages",
      id: atob(this.$route.params.id),
      name: atob(this.$route.params.name),
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Insurance Packages",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "packageName",
          sortable: true,
          label: "PACKAGE NAME",
        },
        {
          key: "addedBy.name",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "ADDED ON",
        },
        {
          key: "yy",
          sortable: true,
          label: "SERVICES",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingPackage: [],
      nameError: "",

      // Value from user input for adding Package
      data: {
        name: "",
        company: atob(this.$route.params.id),
      },
      // edit Package
      editdata: {
        name: "",
        company: atob(this.$route.params.id),
        id: "",
      },
      // delete Package
      deletedata: {
        name: "",
        company: atob(this.$route.params.id),
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["InsurancePackages", "InsuranceStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.InsurancePackages ? this.InsurancePackages.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.InsurancePackages ? this.InsurancePackages.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchInsurancePackages: "insurance/fetchInsurancePacks",
      AddPackage: "insurance/addInsurancePackage",
      EditPackage: "insurance/editInsurancePackage",
      DeletePackage: "insurance/deleteInsurancePackage",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingPackage = this.InsurancePackages.filter((Package) => {
          return Package.packageName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingPackage.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingPackage = [];
      }
    },

    addPackage(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Package name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingPackage.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddPackage(this.data);
    },

    resetAddPackage() {
      this.data.name = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditPackage() {
      this.editdata.name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeletePackage() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.packageName;
      this.editdata.id = data.item.id;
    },
    editPackage(modalId) {
      if (this.editdata.name === "") {
        this.nameError = "Package name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.modal_id = modalId;
      this.EditPackage(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.packageName;
      this.deletedata.id = data.item.id;
    },
    deletePackage(modalId) {
      this.modal_id = modalId;
      this.DeletePackage(this.deletedata);
    },
    ServRedirect(value) {
      this.$router.push(
        `/insurance/insurance_services/${btoa(value.id)}/${btoa(value.packageName)}`
      );
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchInsurancePackages(this.id);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <h2>Insurance Packages for {{ this.name }}</h2>
                <div>
                  <b-button v-if="user_permissions.view_insurance_company" @click="$router.go(-1)" class="float-left" variant="warning"
                    ><i class="fa fa-arrow-left"></i> Go Back</b-button
                  >
                  <b-button v-if="user_permissions.add_insurance_company_packages"
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-package-modal
                    ><i class="fa fa-plus"></i> Add Package</b-button
                  >
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="InsurancePackages ? InsurancePackages : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="user_permissions.edit_insurance_company_packages"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-package-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-package-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-if="user_permissions.delete_insurance_company_packages"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-company-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
                <template #cell(yy)="data">
                  <b-button v-if="user_permissions.view_insurance_company_package_services"
                    @click="ServRedirect(data.item)"
                    size="sm"
                    variant="success"
                    class="m-2"
                    ><i class="fa fa-eye"></i> View</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!InsurancePackages" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- modal starts -->
            <b-modal id="add-package-modal" hide-footer @hidden="resetAddPackage">
              <template #modal-title> Add New Insurance Package </template>
              <div class="form-group mb-3">
                <label>Package Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Package Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('add-package-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="addPackage('add-package-modal')"
                >
                  <i class="fa fa-check"></i>
                  Submit
                  <b-spinner
                    v-if="InsuranceStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-package-modal" hide-footer @hidden="resetEditPackage">
              <template #modal-title> Edit Package {{ editdata.name }}</template>
              <div class="form-group mb-3">
                <label>Package Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Package Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="editdata.name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-package-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editPackage('edit-package-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="InsuranceStatus"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete Package starts -->
            <b-modal id="delete-company-modal" hide-footer @hidden="resetDeletePackage">
              <template #modal-title>
                <h4 class="text-danger">
                  Delete Package {{ deletedata.name }}
                </h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Package? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-company-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deletePackage('delete-company-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="InsuranceStatus"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
